import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l16 0","key":"svg-0"}],["path",{"d":"M8 12l8 0","key":"svg-1"}],["path",{"d":"M6 18l12 0","key":"svg-2"}]]

/**
 * IconAlignCenter
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYWxpZ24tY2VudGVyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDZsMTYgMCIgLz4KICA8cGF0aCBkPSJNOCAxMmw4IDAiIC8+CiAgPHBhdGggZD0iTTYgMThsMTIgMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/align-center
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconAlignCenter = createReactComponent('outline', 'align-center', 'AlignCenter', __iconNode);

export default IconAlignCenter;